import { Router } from 'vue-router'
import i18n from '@/locales'
import { ICourseChapters, ICourseDetails, CourseWareDetails, CourseDetail } from '@/api/Models/CourseDetail'

// 对返回结果的处理 无权限 4001542 4001543 2，无内容 4001512 4001519 1
export const reqResHandle = (code: number, msg: string, router: Router) => {
  let imgSrc = 'error.png'
  if (code === 4001542 || code === 4001543) {
    imgSrc = 'no_permission.png'
  } else if (code === 4001512 || code === 4001519) {
    imgSrc = 'empty.png'
  }
  if (code === 429) {
    window.dispatchEvent(new CustomEvent('global_rate_limited', { detail: { path: window.location.pathname } }))
    return
  }
  router.replace({ name: 'error', state: { status: { info: msg, imgSrc } } })
}

export const getTime = (time: number) => {
  // 转换为式分秒
  const timerSecond = time / 1000
  const h = parseInt((timerSecond / 60 / 60) + '')
  const m = parseInt(((timerSecond / 60) % 60) + '')
  const s = parseInt((timerSecond % 60) + '')
  return [h, m, s] // 作为返回值返回
}

// 完成学习条件 处理
export const getCompleteTips = (needStudyTime: number) => {
  const timer = getTime(needStudyTime)
  let timerTips
  if (timer[0] < 0 || timer[1] < 0 || timer[2] < 0) {
    timerTips = i18n.global.t('app_course_over')
  } else if (timer[0] === 0 && timer[1] === 0 && timer[2] === 0) {
    // h m s 都是 0
    timerTips = i18n.global.t('app_course_over')
  } else {
    // h = m = s != 0
    const timerH = timer[0] !== 0 ? ' ' + timer[0] + ' ' + i18n.global.t('pc_lesson_hour') : ''
    const timerM = timer[1] !== 0 ? ' ' + timer[1] + ' ' + i18n.global.t('pc_lesson_minute') : ''
    const timerS = timer[2] !== 0 ? ' ' + timer[2] + ' ' + i18n.global.t('pc_lesson_second') : ''
    timerTips = i18n.global.t('app_course_unstudy') + timerH + timerM + timerS
  }
  return timerTips
}

// 获取下节课的学习信息
export const getStudyNextFun = (arr: ICourseDetails[], id: string | number, isChapter: boolean) => {
  let courseWareDetails
  if (isChapter) {
    courseWareDetails = getCatalogueList(arr)
  } else {
    courseWareDetails = arr
  }
  if (courseWareDetails?.length > 0) {
    const curIndex = courseWareDetails.findIndex((course) => {
      return course.bizId === id
    })
    const nextInfo = curIndex === courseWareDetails.length - 1 ? null : courseWareDetails[curIndex + 1]
    return nextInfo
  } else {
    return null
  }
}

// 根据数组【h，m，s】 返回 共h小时m分钟s秒  共h小时m分钟  共s秒 共m分钟s秒 共m分钟
export const handleTime = (timer: number[]) => {
  // h = m = s != 0
  const timerH = timer[0] !== 0 ? timer[0] + i18n.global.t('pc_lesson_hour') : ''
  const timerM = timer[1] !== 0 ? timer[1] + i18n.global.t('pc_lesson_minute') : ''
  const timerS = timer[2] !== 0 ? timer[2] + i18n.global.t('pc_lesson_second') : ''
  return i18n.global.t('course_total') + timerH + timerM + timerS
}

// 目录的长度
export const getChapterLength = (arr: ICourseChapters[]) => {
  if (arr && arr.length > 0) {
    return arr.reduce((acc, obj) => {
      return acc + (obj?.lmsCourseDetails?.length || 0)
    }, 0)
  } else {
    return 0
  }
}

export const shareDescription = [
  i18n.global.t('course_share_first'),
  i18n.global.t('course_share_second'),
  i18n.global.t('course_share_third'),
  i18n.global.t('course_share_four'),
  i18n.global.t('course_share_five'),
  i18n.global.t('course_share_six'),
  i18n.global.t('course_share_seven'),
  i18n.global.t('course_share_eight')
]

// 目录数组转为课件数组
export const getCatalogueList = (arr: ICourseDetails[] | ICourseChapters[]) => {
  // @ts-ignore
  return arr.flatMap(item => item.lmsCourseDetails)
}

export function isDocOrImg(courseInfo: CourseWareDetails | CourseDetail) {
  return courseInfo.courseWareType === 1 || courseInfo.courseWareType === 3
}
